import EndianUiComponents from 'eos-ui-core'

export default EndianUiComponents.store.errors
